import {
  productFamilyIdFormat,
  productFamilyImageIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod";

const RedoSuppliesProductFamilyImageSchema_ = z.object({
  id: productFamilyImageIdFormat.schema,
  url: z.string(),
  altText: z.string(),
});
export const RedoSuppliesProductFamilyImageSchema: z.ZodType<RedoSuppliesProductFamilyImage> =
  RedoSuppliesProductFamilyImageSchema_;
export interface RedoSuppliesProductFamilyImage
  extends z.infer<typeof RedoSuppliesProductFamilyImageSchema_> {}

const RedoSuppliesProductSchema_ = z.object({
  id: productIdFormat.schema,
  price: z.number().nullable(),
  currency: z.string().nullable(),
});
export const RedoSuppliesProductSchema: z.ZodType<RedoSuppliesProduct> =
  RedoSuppliesProductSchema_;
export interface RedoSuppliesProduct
  extends z.infer<typeof RedoSuppliesProductSchema_> {}

const RedoSuppliesProductFamilySchema_ = z.object({
  id: productFamilyIdFormat.schema,
  title: z.string(),
  images: z.array(RedoSuppliesProductFamilyImageSchema),
  products: z.array(RedoSuppliesProductSchema),
});
export const RedoSuppliesProductFamilySchema: z.ZodType<RedoSuppliesProductFamily> =
  RedoSuppliesProductFamilySchema_;
export interface RedoSuppliesProductFamily
  extends z.infer<typeof RedoSuppliesProductFamilySchema_> {}

export const getRedoSuppliesProducts = {
  name: "getRedoSuppliesProducts" as const,
  input: z.object({ query: z.string().optional() }),
  output: z.object({
    productFamilies: z.array(RedoSuppliesProductFamilySchema),
    totalCount: z.number(),
  }),
};
